import { render, staticRenderFns } from "./MarketingSms.vue?vue&type=template&id=2105375e&scoped=true"
import script from "./MarketingSms.vue?vue&type=script&lang=js"
export * from "./MarketingSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2105375e",
  null
  
)

export default component.exports